import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaTags: Record<string, string> = {
      'meta[name="description"]': description,
      'meta[name="keywords"]': keywords,
      'meta[property="og:title"]': ogTitle || title,
      'meta[property="og:description"]': ogDescription || description,
      'meta[property="og:url"]': canonicalUrl,
      'meta[property="og:type"]': ogType,
      'meta[name="twitter:title"]': ogTitle || title,
      'meta[name="twitter:description"]': ogDescription || description,
    };

    Object.entries(metaTags).forEach(([selector, value]) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute('content', value);
    });

    const linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) linkCanonical.setAttribute('href', canonicalUrl);

    if (schema) {
      let scriptEl = document.querySelector('#schema-jsonld');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = 'schema-jsonld';
        scriptEl.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, schema]);

  return null;
}